import type { CSSProperties } from "react";

/** Style CSS `object-position` pour un recadrage de photo de profil persisté. */
export const profilePhotoObjectStyle = (
  position?: string | null,
): CSSProperties | undefined => {
  const value = position?.trim();
  return value ? { objectPosition: value } : undefined;
};
